// @ts-nocheck
import clsx from 'clsx'
import {FC, Fragment} from 'react'
import {Row} from 'react-table'
import {charge} from '../../core/_models'
import {ChargeDetailRow} from './ChargeDetailRow'

type Props = {
  row: Row<charge>
  isOpen: boolean
  onToggle: (id: number) => void
}

const CustomRow: FC<Props> = ({row, isOpen, onToggle}) => {
  const charge = row.original

  return (
    <Fragment>
      <tr {...row.getRowProps()} className='accordion-item'>
        <td className='text-center min-w-50px'>
          <button
            type='button'
            className='btn btn-icon btn-sm btn-color-muted btn-active-color-danger'
            onClick={() => onToggle(charge.id)}
          >
            <i className={clsx('bi', isOpen ? 'bi-chevron-up' : 'bi-chevron-down')}></i>
          </button>
        </td>
        {row.cells.map((cell) => {
          return (
            <td
              {...cell.getCellProps()}
              className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
            >
              {cell.render('Cell')}
            </td>
          )
        })}
      </tr>
      <ChargeDetailRow charge={charge} colSpan={row.cells.length + 1} isOpen={isOpen} />
    </Fragment>
  )
}
export {CustomRow}